import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const SeparatorIcon = props => {
  return (
    <Svg
      width={2}
      height={17}
      viewBox="0 0 2 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path d="M1 .5v16" stroke="#3876AA" strokeWidth={0.5} />
    </Svg>
  );
};

export default SeparatorIcon;
